import Experience from "../Experience";
import * as THREE from 'three'

export default class Fence
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        //Debug
        this.debug = this.experience.debug
        if(this.debug.active){
            this.debugFolder = this.debug.gui.addFolder("Fence")
        }

        this.borderFence = this.resources.items.fence        
        this.setFence()
    }

    setFence()
    {
        //Group
        this.group = new THREE.Group()
        this.group.position.set(-5, 0.4, -7)


        //Model
        for(let i = 0;  i < 9; i++)
        {
            this.fence = this.borderFence.scene.clone()
            this.fence.scale.setScalar(2)
            this.fence.position.z = 2.3 * i

            //Adding models to the scene
            this.group.add(this.fence)
        }

        //Clone Group
        this.group2 = this.group.clone()
        this.group2.position.set(18, 0.4, -7)

        //Adding group to the scene
        this.scene.add(this.group)
        this.scene.add(this.group2)


        this.group.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.castShadow = true
            }
        })

        this.group2.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.castShadow = true
            }
        })

        this.group3 = new THREE.Group()

        for(let i = 0;  i < 10; i++)
            {
                this.fence = this.borderFence.scene.clone()
                this.fence.scale.setScalar(2)
                this.fence.position.z = 2.3 * i
    
                //Adding models to the scene
                this.group3.add(this.fence)
            }
            
        this.scene.add(this.group3)
        this.group3.rotation.y = Math.PI * 0.5
        this.group3.position.set(-4, 0.4, 12.7)

        this.group3.traverse((child) =>
            {
                if(child instanceof THREE.Mesh)
                {
                    child.castShadow = true
                }
            })
    

        //Debug
        
    }
}